import { useGlobalSearchParams, useRouter } from 'expo-router'
import { useCallback } from 'react'
import { ContactFlow } from '~/components/contacts/ContactFlow'
import ScreenView from '~/components/layout/ScreenView'

function AddContactPage() {
  const router = useRouter()

  const { assetId } = useGlobalSearchParams<{
    assetId?: string
  }>()

  const handleFlowComplete = useCallback(
    (contactId?: string) => {
      router.replace(
        assetId
          ? `/(authenticated)/property/${assetId}`
          : contactId
            ? {
                pathname: '/leads/[leadId]',
                params: { leadId: contactId, assetId: assetId || undefined },
              }
            : {
                pathname: '/(authenticated)',
                params: { view: 'leads' },
              }
      )
    },
    [router, assetId]
  )

  return (
    <ScreenView>
      <ContactFlow onContactSaved={handleFlowComplete} onCancel={handleFlowComplete} />
    </ScreenView>
  )
}

export default AddContactPage
